__turbopack_context__.v({
  "dropdown_is_showing": "styles-module-scss-module__RSpK4q__dropdown_is_showing",
  "dropdown_menu": "styles-module-scss-module__RSpK4q__dropdown_menu",
  "open_house": "styles-module-scss-module__RSpK4q__open_house",
  "open_house_date": "styles-module-scss-module__RSpK4q__open_house_date",
  "open_house_date_secondary": "styles-module-scss-module__RSpK4q__open_house_date_secondary",
  "open_houses_wrapper": "styles-module-scss-module__RSpK4q__open_houses_wrapper",
});
